// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmUyv7DkK5DvoGHGQQNN {
  position: absolute;
  top: 140px;
  width: 100%;
  height: calc(100vh - 230px);
  overflow-y: auto;
}
.SmUyv7DkK5DvoGHGQQNN .ant-menu-submenu-title,
.SmUyv7DkK5DvoGHGQQNN .ant-menu-item-selected {
  border-radius: 0 50px 50px 0;
}
.SmUyv7DkK5DvoGHGQQNN .ant-menu-submenu-title img,
.SmUyv7DkK5DvoGHGQQNN .ant-menu-item-selected img {
  width: 14px;
  height: 14px;
}
.SmUyv7DkK5DvoGHGQQNN .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: rgba(55, 0, 60, 0.18) !important;
}
.SmUyv7DkK5DvoGHGQQNN .ant-menu-submenu-open > div {
  background-color: rgba(55, 0, 60, 0.18);
}
.SmUyv7DkK5DvoGHGQQNN .ant-menu-item::after {
  border-right: 0 !important;
}
.SmUyv7DkK5DvoGHGQQNN .YgooOsAOSrZhrAGo0PSm {
  border-right: none;
}
.SmUyv7DkK5DvoGHGQQNN .RVYLBbwYgqMf3wLTzzMX {
  padding-right: 10px;
}
.SmUyv7DkK5DvoGHGQQNN .jwCXHvRTF9edGUN9_E4n {
  padding-right: 7px;
}
.SmUyv7DkK5DvoGHGQQNN .FF813sSfAXn3un22uudg {
  background-color: rgba(55, 0, 60, 0.18) !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/sidebar-menu/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;AACF;AACE;;EAOE,4BAAA;AAJJ;AADI;;EACE,WAAA;EACA,YAAA;AAIN;AAEE;EACE,kDAAA;AAAJ;AAQE;EACE,uCAAA;AANJ;AASE;EACE,0BAAA;AAPJ;AAUE;EACE,kBAAA;AARJ;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,kBAAA;AAVJ;AAaE;EACE,kDAAA;AAXJ","sourcesContent":[".sidebar_menu_wrapper {\n  position: absolute;\n  top: 140px;\n  width: 100%;\n  height: calc(100vh - 230px); // 140 from the top, and 90 (30 + 30 + 30) from the bottom logout link\n  overflow-y: auto;\n\n  :global .ant-menu-submenu-title,\n  :global .ant-menu-item-selected {\n    img {\n      width: 14px;\n      height: 14px;\n    }\n\n    border-radius: 0 50px 50px 0;\n  }\n\n  :global .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n    background-color: rgba(55, 0, 60, 0.18) !important;\n  }\n\n  // :global .ant-menu-submenu-open > div {\n  //   background-color: rgba(55, 0, 60, 0.18);\n\n  // }\n\n  :global .ant-menu-submenu-open > div {\n    background-color: rgba(55, 0, 60, 0.18);\n  }\n\n  :global .ant-menu-item::after {\n    border-right: 0 !important;\n  }\n\n  .nav_menu {\n    border-right: none;\n  }\n\n  .nav_menu_open {\n    padding-right: 10px;\n  }\n\n  .nav_menu_closed {\n    padding-right: 7px;\n  }\n\n  .active {\n    background-color: rgba(55, 0, 60, 0.18) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar_menu_wrapper": `SmUyv7DkK5DvoGHGQQNN`,
	"nav_menu": `YgooOsAOSrZhrAGo0PSm`,
	"nav_menu_open": `RVYLBbwYgqMf3wLTzzMX`,
	"nav_menu_closed": `jwCXHvRTF9edGUN9_E4n`,
	"active": `FF813sSfAXn3un22uudg`
};
export default ___CSS_LOADER_EXPORT___;
